import React from "react";
import { Link, LinkProps } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { buildLanguageUrl, SupportedLanguage } from "../utils/languageRoutes";

interface LanguageLinkProps extends Omit<LinkProps, "to"> {
  to: string;
  language?: SupportedLanguage;
}

export const LanguageLink: React.FC<LanguageLinkProps> = ({
  to,
  language,
  children,
  ...props
}) => {
  const { i18n } = useTranslation();
  const currentLanguage = (language ||
    i18n.language ||
    "en") as SupportedLanguage;
  const languageUrl = buildLanguageUrl(to, currentLanguage);

  return (
    <Link to={languageUrl} {...props}>
      {children}
    </Link>
  );
};
